const imgList = document.getElementById("imgList");
const loadMore = document.getElementById("loadMore");
let i=1
const API_KEY = "51148638-4215382d54794cb096cce3e5a"

fetch(`https://pixabay.com/api/?key=${API_KEY}&image_type=photo&per_page=10&page=${i}`)
    .then(res => {return res.json()})
    .then(data => {
    console.log(data)
    imgList.innerHTML = createMarkUp(data.hits)
})

function createMarkUp(data) {
    const newImages = data.map((image)=> 
        `<li class="img__list__item">
            <img src=${image.largeImageURL} alt=${image.tags} class="images__photos" loading="lazy" onload="this.parentElement.classList.add('loaded')">
        </li>`
    ).join('')
    return newImages
}
loadMore.addEventListener("click", ()=> {
    i++
    fetch(`https://pixabay.com/api/?key=${API_KEY}&image_type=photo&per_page=10&page=${i}`)
    .then(res => {return res.json()})
    .then(data => {
        console.log(data)
        imgList.innerHTML += createMarkUp(data.hits)
    })
})